import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PictureViewerService } from 'app/_modules/picture-viewer/picture-viewer.service';
import { ResourceService } from 'app/_service/resource/resource.service';

@Component({
  selector: 'app-you-chat-log',
  templateUrl: './you-chat-log.component.html',
  styleUrls: ['./you-chat-log.component.scss']
})
export class YouChatLogComponent implements OnChanges {
  @Input()
  currentUser: any;

  _messages: any = {}
  _timestamps: any[] = [];

  @Input() set messages(value: boolean) {
    this._messages = value
    this._timestamps = Object.keys(value);
  }

  @Input() isUserBlocked = false;
  @Output()
  onChanged = new EventEmitter();

  @Output()
  onAppeared = new EventEmitter();

  @Output()
  onOpenViewer = new EventEmitter();

  @Input()
  fromSticky = false;

  constructor(
    public _resourceService: ResourceService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.onChanged.emit();
  }

  onAppear(message: any) {
    this.onAppeared.emit(message);
  }

  showPictureViewer(message) {
    this.onOpenViewer.emit(message)
  }

  getMembership(gid) {
    let membership = '';
    switch (gid) {
      case 0:
        membership = '';
        break;
      case 1:
        membership = 'gvip';
        break;
      case 2:
        membership = 'gvip';
        break;
      case 3:
        membership = 'royalVip';
        break;
      case 4:
        membership = 'cpvip';
        break;
      case 101:
        membership = 'cpvip';
        break;
      case 102:
        membership = 'cpvip';
        break;
      default:
        membership = 'vip';
    }
    return membership;
  }

}
